/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminGetEmailHistoryOptions, AdminGetEmailHistoryResponses } from '../../models/AdminGetEmailHistory'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get paginated email send records.
 * @summary Get Email Sends
 * {@link /admin/org/email-history}
 */
export function adminGetEmailHistory<ThrowOnError extends boolean = true>(options: Options<AdminGetEmailHistoryOptions, ThrowOnError> = {}): Promise<UnwrappedResult<AdminGetEmailHistoryResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/admin/org/email-history', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminGetEmailHistoryResponses, ThrowOnError>>
}
